// Gestion/GestiondeCita.js
import React, { useState, useEffect,useRef  } from 'react';
import { Dialog, Box, Typography } from '@mui/material';
import axios from 'axios';
import Swal from 'sweetalert2';
import 'bootstrap/dist/css/bootstrap.min.css';
import './GestiondeCita.css';
import Servicios from './Servicios';
import DatosCita from './DatosCita';
import SeleccionarTratamiento from '../SeleccionarTratamiento';
import SeleccionarProducto from '../SeleccionarProducto';
import VerFactura from './verFactura';
import { Modal, Button } from '@mui/material'; // Asegúrate de tener esto
import SolicitarReview from "./SolicitarReview";
const GestiondeCita = ({ open, onClose, idCita, onRecargarCitas  }) => {

  const timeoutRef = useRef(null);
  const [mostrarFactura, setMostrarFactura] = useState(false);


// Nuevos estados
const [modalPagoAbierto, setModalPagoAbierto] = useState(false);
const [pagoSeleccionado, setPagoSeleccionado] = useState('');

const [modalReviewAbierto, setModalReviewAbierto] = useState(false);
  const [pestanaActiva, setPestanaActiva] = useState('tratamientos');
  const [citaData, setCitaData] = useState(null);
  const [estadoCita, setEstadoCita] = useState(null);

  const [estadoTicket, setEstadoTicket] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Función para actualizar estadoTicket basado en citaData
  const actualizarEstadoTicket = (data) => {
    if (!data) return;
    
    const nuevoTicket = {
      id_cita: data.id_cita,
      id_cliente: data.id_cliente,
      id_empleado: data.id_empleado,
      nombre_cliente: data.nombre_cliente,
      apellidos_cliente: data.apellidos_cliente,
      fecha: new Date().toLocaleString('sv-SE', { timeZone: 'Europe/Madrid' }).replace('T', ' '),


      total: data.resumen?.total || 0,
    totalConDescuento: data.resumen?.totalConDescuento ?? null,

      tipo_pago: estadoTicket?.tipo_pago || "", // Mantener el tipo_pago si ya existe
      detalles: [
        ...(data.tratamientos || []).map(t => ({
          tipo: "tratamiento",
          nombre: t.nombre,
          precio: parseFloat(t.precio),
          cantidad: 1,
          subtotal: parseFloat(t.precio)
        })),
        ...(data.productos || []).map(p => ({
          tipo: "producto",
          nombre: p.nombre || p.nombre_producto,
          precio: parseFloat(p.precio),
          cantidad: 1,
          subtotal: parseFloat(p.precio)
        }))
      ]
    };

    console.log("🔄 Actualizando estadoTicket:", nuevoTicket); // LOG IMPORTANTE
    setEstadoTicket(nuevoTicket);
  };

  useEffect(() => {
    console.log("🔄 citaData actualizado:", citaData);
  }, [citaData]);
  
  const actualizarEstadoCita = (data) => {
    if (!data) return;
  
    const nuevoEstadoCita = {
      id_cita: data.id_cita,
      tratamientos: (data.tratamientos || []).map(t => ({
        id_tratamiento: t.id_tratamiento,
        
        id_empleado: t.id_empleado || null,
        duracion: t.duracion,
        precio: parseFloat(t.precio)
      })),
      productos: (data.productos || []).map(p => ({
        id_producto_cita: p.id_producto_cita,
        id_producto: p.id_producto,
        nombre_producto: p.nombre || p.nombre_producto,
        precio: parseFloat(p.precio),
        id_empleado: p.id_empleado || null  // ✅ aseguramos que se envíe
      }))
    };
    
  
    console.log("🟡 EstadoCita actualizado:", JSON.stringify(nuevoEstadoCita, null, 2)); // 🪵 Log para depuración
    setEstadoCita(nuevoEstadoCita);
  };
  
  useEffect(() => {
    const fetchCitaData = async () => {
      if (!idCita) return;
  
      try {
        setLoading(true);
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/citasporid/${idCita}`);
        console.log("Datos de la cita recibidos de la API:", response.data);
        setCitaData(response.data);
        actualizarEstadoCita(response.data);
        actualizarEstadoTicket(response.data);
        setError(null);
  
        // Verificar si ya tiene ticket
        const ticketResponse = await axios.get(`${process.env.REACT_APP_API_URL}/api/verificarticket/${idCita}`);
        if (ticketResponse.data.tieneTicket) {
          setMostrarFactura(true); // Mostrar el modal de factura
        }
  
      } catch (err) {
        console.error('Error fetching cita data:', err);
        setError('Error al cargar los datos de la cita');
        setCitaData(null);
        setEstadoTicket(null);
      } finally {
        setLoading(false);
      }
    };
  
    if (open) {
      fetchCitaData();
    }
  }, [idCita, open]);
  
  // Sincronizar estadoTicket cuando cambia citaData
  useEffect(() => {
    if (citaData) {
      actualizarEstadoTicket(citaData);
      actualizarEstadoCita(citaData);
    }
  }, [citaData]);

  const handleEmpleadoChange = (tipo, index, nuevoIdEmpleado) => {
    setCitaData((prev) => {
      if (!prev) return prev;
  
      let nuevosTratamientos = [...(prev.tratamientos || [])];
      let nuevosProductos = [...(prev.productos || [])];
  
      if (tipo === 'Tratamiento') {
        nuevosTratamientos[index] = {
          ...nuevosTratamientos[index],
          id_empleado: nuevoIdEmpleado
        };
      } else if (tipo === 'Producto') {
        nuevosProductos[index] = {
          ...nuevosProductos[index],
          id_empleado: nuevoIdEmpleado
        };
      }
  
      const nuevoCitaData = {
        ...prev,
        tratamientos: nuevosTratamientos,
        productos: nuevosProductos
      };
  
      actualizarEstadoCita(nuevoCitaData);
      actualizarEstadoTicket(nuevoCitaData);
  
      return nuevoCitaData;
    });
  };
  
  

const handleSeleccionProducto = (producto) => {
  setCitaData((prev) => {
    const nuevos = [...(prev.productos || []), {
   
      id_producto: producto.id_producto,
      nombre: producto.nombre_producto,
      precio: producto.precio,
      id_empleado: null // Inicialmente sin empleado asignado
    }];

    const totalTratamientos = (prev.tratamientos || []).reduce((acc, t) => acc + parseFloat(t.precio || 0), 0);
    const totalProductos = nuevos.reduce((acc, p) => acc + parseFloat(p.precio || 0), 0);

    const nuevoResumen = {
      ...prev.resumen,
      total: parseFloat(totalTratamientos + totalProductos).toFixed(2)
    };

    const nuevoCitaData = {
      ...prev,
      productos: nuevos,
      resumen: nuevoResumen
    };

    actualizarEstadoCita(nuevoCitaData);
    actualizarEstadoTicket(nuevoCitaData);

    return nuevoCitaData;
  });
};

  

  const handleSeleccionTratamiento = (tratamiento) => {
    setCitaData((prev) => {
      const nuevos = [...(prev.tratamientos || []), {
        id_tratamiento: tratamiento.id_tratamiento,
        nombre: tratamiento.nombre_tratamiento,
        duracion: tratamiento.duracion_tratamiento,
        precio: tratamiento.precio_tratamiento
      }];
      
      const nuevoResumen = {
        ...prev.resumen,
        total: nuevos.reduce((acc, t) => acc + parseFloat(t.precio || 0), 0)
      };

      return {
        ...prev,
        tratamientos: nuevos,
        resumen: nuevoResumen
      };
    });
  };



  
  const handleTipoPagoChange = (tipo) => {
    setEstadoTicket(prev => ({
      ...prev,
      tipo_pago: tipo
    }));
    console.log("💳 Tipo de pago actualizado:", tipo); // LOG
  };

  const handleCrearTicket = () => {
    setModalPagoAbierto(true);
  };
  

  const confirmarPagoYCrearTicket = async () => {
    if (!pagoSeleccionado) {
      alert("Selecciona una opción de pago.");
      return;
    }
  
    const nuevoTicket = {
      ...estadoTicket,
      tipo_pago: pagoSeleccionado,
      
    };
  
    try {
      // Enviar los datos del ticket y actualizar la cita
      await axios.post(`${process.env.REACT_APP_API_URL}/api/crearticket`, nuevoTicket);
      await axios.post(`${process.env.REACT_APP_API_URL}/api/editarcita`, estadoCita);
  
      // Mostrar la factura
      setModalReviewAbierto(true);
      setModalPagoAbierto(false);
      setMostrarFactura(true);
  
      // Aquí agregamos un timeout para dar tiempo suficiente para mostrar la factura
      timeoutRef.current = setTimeout(() => {
        setMostrarFactura(false);
        if (onRecargarCitas) onRecargarCitas();
        onClose();
        timeoutRef.current = null;
      }, 10000);
    
    } catch (error) {
      console.error("❌ Error al crear el ticket:", error);
      Swal.fire({
        icon: 'error',
        title: 'Error al crear el ticket',
        text: 'Existen tratamientos o productos sin asignar a un Peluquero.',
        confirmButtonText: 'Entendido'
      });
    }
    
  };
  // Cuando cierras el modal manualmente:
const cerrarModalFactura = () => {
  if (timeoutRef.current) {
    clearTimeout(timeoutRef.current);
    timeoutRef.current = null;
  }
  setMostrarFactura(false);
};

  

const handleSolicitarReview = async () => {
  const telefono =
    citaData?.telefono ||
    citaData?.telefono_cliente ||
    citaData?.cliente?.telefono;

  if (!telefono) {
    Swal.fire({
      icon: "warning",
      title: "Sin teléfono",
      text: "Este cliente no tiene teléfono registrado.",
    });
    return;
  }

  try {
    await axios.post(
      `${process.env.REACT_APP_API_URL}/api/solicitar-review`,
      { telefono }
    );

    Swal.fire({
      icon: "success",
      title: "Review enviada",
      text: "La solicitud de reseña se ha enviado correctamente.",
      timer: 1500,
      showConfirmButton: false,
    });

    setModalReviewAbierto(false);

  } catch (error) {
    console.error("Error enviando review:", error);

    Swal.fire({
      icon: "error",
      title: "Error",
      text: "No se pudo enviar la review.",
    });
  }
};


  
  const handleEliminarTratamiento = (index) => {
    setCitaData((prev) => {
      const nuevos = (prev.tratamientos || []).filter((_, i) => i !== index);
      const nuevoResumen = {
        ...prev.resumen,
        total: nuevos.reduce((acc, t) => acc + parseFloat(t.precio || 0), 0)
      };
      const nuevoCitaData = {
        ...prev,
        tratamientos: nuevos,
        resumen: nuevoResumen
      };
      actualizarEstadoCita(nuevoCitaData);
      actualizarEstadoTicket(nuevoCitaData);
      return nuevoCitaData;
    });
  };

  const handleEliminarProducto = (index) => {
    setCitaData((prev) => {
      const nuevos = (prev.productos || []).filter((_, i) => i !== index);
  
      const totalTratamientos = (prev.tratamientos || []).reduce((acc, t) => acc + parseFloat(t.precio || 0), 0);
      const totalProductos = nuevos.reduce((acc, p) => acc + parseFloat(p.precio || 0), 0);
  
      const nuevoResumen = {
        total: parseFloat(totalTratamientos + totalProductos).toFixed(2),
        totalTratamientos,
        totalProductos
      };
  
      const nuevoCitaData = {
        ...prev,
        productos: nuevos,
        resumen: nuevoResumen
      };
  
      actualizarEstadoCita(nuevoCitaData);
      actualizarEstadoTicket(nuevoCitaData);
  
      return nuevoCitaData;
    });
  };
  


  return (
    <Dialog open={open} onClose={onClose} 
    maxWidth={false} // desactiva los tamaños predefinidos
     fullWidth 
     PaperProps={{
      style: {
        width: '85vw',       // o '1000px', '1200px', etc.
        maxWidth: '85vw',
        minHeight: '95vh'
      }
    }}
     
     >
      <Box sx={{ p: 3, height: '95vh' }} className="container-fluid">
        {loading && <Typography>Cargando datos...</Typography>}
        {error && <Typography color="error">{error}</Typography>}
        
        {citaData && (
          <div className="row h-100 g-3">
            {/* Columna Izquierda - Datos de la cita */}
            <div className="col-md-6 d-flex flex-column" style={{ height: 'fit-content' }}>
              <DatosCita citaData={citaData} />

              {/* Pestañas de selección */}
              <div className="mt-4">
                <div className="btn-group w-100" role="group">
                  <button
                    className={`btn btn-outline-primary ${pestanaActiva === 'tratamientos' ? 'active' : ''}`}
                    onClick={() => setPestanaActiva('tratamientos')}
                  >
                    Tratamientos
                  </button>
                  <button
                    className={`btn btn-outline-secondary ${pestanaActiva === 'productos' ? 'active' : ''}`}
                    onClick={() => setPestanaActiva('productos')}
                  >
                    Productos
                  </button>
                </div>

                {pestanaActiva === 'tratamientos' && (
                  <div className="mt-3">
                    <SeleccionarTratamiento
                      onSeleccion={handleSeleccionTratamiento}
                    />
                  </div>
                )}

{pestanaActiva === 'productos' && (
  <div className="mt-3">
    <SeleccionarProducto onSeleccion={handleSeleccionProducto} />
  </div>
)}

              </div>
            </div>

            {/* Columna Derecha con Servicios */}
            <div className="col-md-6 d-flex flex-column">
              <div className="h-100 overflow-auto">
              <Servicios
  citaData={citaData}
  onEmpleadoChange={handleEmpleadoChange}
  onEliminarTratamiento={handleEliminarTratamiento}
  onEliminarProducto={handleEliminarProducto}
  onActualizarCitaData={setCitaData}
  onActualizarEstadoTicket={actualizarEstadoTicket}
/>

              </div>
              
              {/* Botón para crear ticket */}
              <button 
                className="btn btn-primary mt-3"
     
                onClick={handleCrearTicket}
              >
                Cobrar
              </button>
            </div>
          </div>
        )}
      </Box>




      <Modal open={modalPagoAbierto} onClose={() => setModalPagoAbierto(false)}>
  <Box sx={{
    position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
    width: 400, bgcolor: 'background.paper', boxShadow: 24, p: 4, borderRadius: 2
  }}>
    <h5>Selecciona método de pago</h5>
    <div className="btn-group w-100 mt-3">
      <button 
        className={`btn btn-outline-primary ${pagoSeleccionado === 'efectivo' ? 'active' : ''}`}
        onClick={() => setPagoSeleccionado('efectivo')}
      >
        Efectivo
      </button>
      <button 
        className={`btn btn-outline-primary ${pagoSeleccionado === 'tarjeta' ? 'active' : ''}`}
        onClick={() => setPagoSeleccionado('tarjeta')}
      >
        Tarjeta
      </button>
    </div>

    <div className="d-flex justify-content-end mt-4">
      <Button variant="contained" color="primary" onClick={confirmarPagoYCrearTicket}>
        Continuar
      </Button>
    </div>
  </Box>
</Modal>


<Modal open={mostrarFactura} onClose={cerrarModalFactura}>
  <Box sx={{
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '20vw',
    minHeight: '80vh',
    maxHeight: '90vh',
    overflowY: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    borderRadius: 2
  }}>
    <VerFactura idCita={idCita} 
     onCancelarImpresion={() => setMostrarFactura(false)}
    />
  </Box>
</Modal>

<SolicitarReview
  open={modalReviewAbierto}
  onClose={() => setModalReviewAbierto(false)}
  telefono={
    citaData?.telefono ||
    citaData?.telefono_cliente ||
    citaData?.cliente?.telefono
  }
  nombre={`${citaData?.nombre_cliente || ""} ${
    citaData?.apellidos_cliente || ""
  }`}
  onSolicitar={handleSolicitarReview}
/>

    </Dialog>
  );
};

export default GestiondeCita;